// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import { Header, Icon, Loader, Segment } from "semantic-ui-react";
import useCurrent from "../hooks/useCurrent";
import DashboardGrid from "./DashboardGrid";
import DashboardHeader from "./DashboardHeader";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const Dashboard = props => {
  const [dashboard,, loading] = useCurrent();
  const header = React.useMemo(() => /*#__PURE__*/_jsx(DashboardHeader, {
    content: dashboard?.nom
  }), [dashboard?.nom]);
  const grid = React.useMemo(() => /*#__PURE__*/_jsx(DashboardGrid, {
    dashboard: dashboard?.identifiant,
    type: dashboard?.type,
    widgets: dashboard?.widgets
  }), [dashboard?.identifiant, dashboard?.type, dashboard?.widgets]);
  return /*#__PURE__*/_jsx("div", {
    className: "dashboard",
    "data-sentry-component": "Dashboard",
    "data-sentry-source-file": "Dashboard.tsx",
    children: loading ? /*#__PURE__*/_jsx(Loader, {
      active: true
    }) : dashboard ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [header, grid]
    }) : /*#__PURE__*/_jsx(Segment, {
      placeholder: true,
      style: {
        height: "100%"
      },
      children: /*#__PURE__*/_jsxs(Header, {
        icon: true,
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "dashboard"
        }), "Vous n'avez aucun tableau de bord"]
      })
    })
  });
};
export default Dashboard;